import { BrowserRouter, Route, Routes } from "react-router-dom";
import MainPage from "./view/MainPage";
import LoadingPage, { LoadingPageAlt,LoadingPageSameLikeProduct } from "./view/LoadingPage";
import ViewMoreArtPage from "./view/ViewMoreArtPage";
import TypeDetailPage from "./view/TypeDetailPage";
import MoreNews from "./view/MoreNewsPage";
import NewsDetailPage from "./view/NewsDetailPage";
import ContactUs from "./view/ContactUsPage";
import TermOfService, { PrivacyPolicy } from "./view/TermOfServicePage";
import Exhibition from "./view/ExhibitionPage";
import ArtSculptureDetail, { ArtDetailPage, DetailPage } from "./view/type-detail/ArtDetail";
import { useEffect, useState } from "react";
import { apiHandler } from "./view/api/APIHandler";

function App() {

  const [data, setData] = useState()

  useEffect(() => {
    const fetchData = async () => {
      try {

        const data = await apiHandler('items/contact_address');
        setData(data.whatsapp);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  return (

    <BrowserRouter>
      
      <div style={{ display: "none" }}>some images are from unsplash.com</div>
      <Routes>
        <Route>
          <Route path='/' element={<LoadingPageSameLikeProduct />} />
          <Route path='/dashboard' element={<MainPage />} />
          <Route path='/more-art' element={<ViewMoreArtPage />} />
          <Route path='/art/:type' element={<TypeDetailPage />} />
          <Route path='/art/:type/detail/:id' element={<ArtDetailPage />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/tos" element={<TermOfService />} />
          <Route path="/pp" element={<PrivacyPolicy />} />
          <Route path='/more-news' element={<MoreNews />} />
          <Route path='/news-detail/:id' element={<NewsDetailPage />} />
          <Route path='/exhibition' element={<Exhibition />} />
        </Route>
      </Routes>
      <div className="fixed z-[999] cursor-pointer bg-black text-white p-[1vw] text-[1w] right-[1vw] bottom-[1vw]" onClick={() => window.open(data, '_blank')}>Connect with us</div>
    </BrowserRouter>
  );
}

export default App;
